document.addEventListener('DOMContentLoaded', function() {
    const teamMemberDetails = document.querySelectorAll('.team_member');
    const teamMemberPopups = document.querySelectorAll('.team_member_details-popup');
    const overlays = document.querySelectorAll('.team_member_details-popup-overlay');
    const body = document.body;
    const sectionHeader = document.getElementById('shopify-section-header');
    let previouslyClickedSection = null;

    function isMobile() {
        return window.innerWidth <= 768; // Adjust the width threshold as needed
    }

    function showElement(element) {
        element.style.visibility = 'visible';
        element.style.opacity = '1';
        body.style.overflow = 'hidden';
        const nearestSection = element.closest('.shopify-section');

        if (nearestSection) {
            // Reset previously clicked section
            if (previouslyClickedSection && previouslyClickedSection !== nearestSection) {
                resetSection(previouslyClickedSection);
            }

            // Set z-index for current section
            if (isMobile()) {
                nearestSection.style.zIndex = '-6';
            } else {
                nearestSection.style.zIndex = '1';
            }
            nearestSection.style.position = 'relative';
            previouslyClickedSection = nearestSection;

            // Set z-index for the previous section
            const prevSection = nearestSection.previousElementSibling;
            if (prevSection && prevSection.classList.contains('shopify-section')) {
                setSectionZIndex(prevSection, '-6');
            }

            // Set z-index for the next section
            const nextSection = nearestSection.nextElementSibling;
            if (nextSection && nextSection.classList.contains('shopify-section')) {
                setSectionZIndex(nextSection, '-7');
            }
        }

        // sectionHeader.style.zIndex = '0';
    }

    function hideElement(element) {
        element.style.visibility = 'hidden';
        element.style.opacity = '0';
        body.style.overflow = '';
        sectionHeader.style.zIndex = '3';

        if (previouslyClickedSection) {
            resetSection(previouslyClickedSection);
            previouslyClickedSection = null;
        }
    }

    function setSectionZIndex(section, zIndexValue) {
        section.style.zIndex = zIndexValue;
        section.style.position = 'relative';
    }

    function resetSection(section) {
        section.style.zIndex = '';
        section.style.position = '';
    }

    function closePopup() {
        const newPopupContent = document.querySelector('.new-popup-content');
        const onclass = document.querySelector('.new-popup-content-outer');
        newPopupContent.classList.remove('active');
        document.body.style.overflow = '';
        sectionHeader.style.zIndex = '3';
        onclass.classList.remove('active');

        // Reset z-index and position for all sections
        const allSections = document.querySelectorAll('.shopify-section');
        allSections.forEach(function(section) {
            resetSection(section);
        });

        // Reset previouslyClickedSection
        previouslyClickedSection = null;
    }

    function copyContent(event) {
        const teamMember = event.currentTarget;
        const postContent = teamMember.querySelector('.team_member_details-popup').innerHTML;
        const newPopupContent = document.querySelector('.new-popup-content');
        newPopupContent.innerHTML = postContent;
        newPopupContent.classList.add('active');
        const onclass = document.querySelector('.new-popup-content-outer');
        onclass.classList.add('active');
    }

    function handleResize() {
        const teamMembers = document.querySelectorAll('.team_member');
        if (window.innerWidth <= 768) {
            teamMembers.forEach(function(teamMember) {
                teamMember.addEventListener('click', copyContent);
            });
        } else {
            teamMembers.forEach(function(teamMember) {
                teamMember.removeEventListener('click', copyContent);
            });
        }
    }

    teamMemberDetails.forEach(function(details) {
        details.addEventListener('click', function() {
            const popup = details.querySelector('.team_member_details-popup');
            const overlay = details.querySelector('.team_member_details-popup-overlay');
            if (popup && overlay) {
                teamMemberPopups.forEach(function(popup) {
                    hideElement(popup);
                });
                overlays.forEach(function(overlay) {
                    hideElement(overlay);
                });
                showElement(popup);
                showElement(overlay);
            }
        });
    });

    const closeButtons = document.querySelectorAll('.team_member_details-popup .team-cross-icon');
    closeButtons.forEach(function(closeButton) {
        closeButton.addEventListener('click', function(event) {
            event.stopPropagation();
            teamMemberPopups.forEach(function(popup) {
                hideElement(popup);
            });
            overlays.forEach(function(overlay) {
                hideElement(overlay);
            });
        });
    });

    teamMemberPopups.forEach(function(popup) {
        hideElement(popup);
    });
    overlays.forEach(function(overlay) {
        hideElement(overlay);
    });

    document.querySelector('.team-cross-remove').addEventListener('click', closePopup);

    handleResize();
    window.addEventListener('resize', handleResize);

    document.addEventListener('click', function(event) {
        if (event.target.closest('.team-cross-remove')) {
            closePopup();
        }
    });
});
